module.exports = __webpack_public_path__ + "static/media/cross.3cce749d.png";